__webpack_require__.p = "/mi-assets/mi-static/mi-homepage-renderer/web-rel-26.6.1-5d80cc6-11080/_next/";